import { AuthNotice } from "~/feature/auth/type";

export const AUTH_NOTICE_MESSAGE: Record<AuthNotice, string> = {
  [AuthNotice.AlreadySignedIn]: "You're already signed in",
  [AuthNotice.NewAccountsOnly]: "This offer is for new accounts only",
};
